import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStoreState } from "pullstate";
import { createContext, useEffect, useState } from "react";
import Store from "../../utils/Store";
import { clone, cloneDeep, get, isEmpty, set } from "lodash";
import useWebsocket from "../../hooks/useWebsocket";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import constants from "../../utils/constants";
import { getIsOnpremise, isValidDate } from "../../utils";
import getPatients from "./services/getPatients";
import getCounts from "./services/getCounts";
import getSyncStatus from "./services/getSyncStatus";
import { getEmergencyPatients } from "../WorklistTagsSetting/utils";
import { add } from "date-fns";
import getMatchingPatient from "../MatchingPatient/services/getMatchingPatient";
import { downloadFile } from "../ExportMessage/services/downloadService";
import { useRouter } from "next/router";
import useCheckWorklistContainer from "../../hooks/useCheckWorklistContainer";
import getPatientDetails from "./services/getPatientDetails";
import Toast from "../Toast";
import getEnv from "../../utils/getEnv";
import getCloudSyncStatus from "./services/getCloudSyncStatus";
export var PatientsContext = /*#__PURE__*/createContext({});
export var PatientsContextProvider = function PatientsContextProvider(props) {
  var _localStorage, _localStorage2, _localStorage3;
  var children = props.children;
  var pageSize = constants.PAGE_SIZE;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        user: s.user,
        newPatientId: s.newPatientId,
        worklistCloudSyncStatus: s.worklistCloudSyncStatus,
        userInfo: s.userInfo
      };
    }),
    user = _useStoreState.user,
    newPatientId = _useStoreState.newPatientId,
    worklistCloudSyncStatus = _useStoreState.worklistCloudSyncStatus,
    userInfo = _useStoreState.userInfo;
  var userId = get(user, ["sub"], "");
  var isLoggedIn = !isEmpty(user);
  var _useState = useState(""),
    lastId = _useState[0],
    setLastId = _useState[1];
  var _useState2 = useState(null),
    patientsData = _useState2[0],
    setPatientsData = _useState2[1];
  var _useState3 = useState({}),
    updatedMessage = _useState3[0],
    setUpdatedMessage = _useState3[1];
  var _useState4 = useState({}),
    unreadMessages = _useState4[0],
    setUnreadMessages = _useState4[1];
  var _useState5 = useState({}),
    currentPatient = _useState5[0],
    setCurrentPatient = _useState5[1];
  var _useState6 = useState(false),
    isPatientsLoading = _useState6[0],
    setPatientsLoading = _useState6[1];
  var _useState7 = useState(0),
    count = _useState7[0],
    setCount = _useState7[1];
  var _useState8 = useState([]),
    emergencyPatients = _useState8[0],
    setEmergencyPatients = _useState8[1];
  // const [unsyncCount, setUnsyncCount] = useState(0);
  var _useState9 = useState(false),
    isCountLoading = _useState9[0],
    setIsCountLoading = _useState9[1];
  var _persistedFilters = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(constants.PERSISTED.filterObj);
  var isWorkList = useCheckWorklistContainer();
  var _useState0 = useState(_persistedFilters ? JSON.parse(_persistedFilters) : constants.DEEFAULT_FILTER),
    filters = _useState0[0],
    setFilters = _useState0[1];
  var _persistedSavedFilters = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(constants.PERSISTED.savedFilterData);
  var _useState1 = useState(_persistedSavedFilters ? JSON.parse(_persistedSavedFilters) : null),
    savedFilterData = _useState1[0],
    setSavedFilterData = _useState1[1];
  var _persistedFullWidthWorklist = (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.getItem(constants.PERSISTED.isFullWidthWorklist);
  var _useState10 = useState(!!_persistedFullWidthWorklist),
    isFullWidthWorklist = _useState10[0],
    setIsFullWidthWorklist = _useState10[1];
  var _useState11 = useState([]),
    matchingPatients = _useState11[0],
    setMatchingPatients = _useState11[1];
  var _useWebsocket = useWebsocket("/worklist/".concat(userId, "/"), !isEmpty(user)),
    socket = _useWebsocket.socket,
    wsData = _useWebsocket.wsData;
  var router = useRouter();
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var isOnPremise = getIsOnpremise();
  var isFormModalOpen = getEnv("NEXT_PUBLIC_OPEN_FORM_MODAL_AFTER_REGISTRATION") === "true";
  var currentPatientUid = get(currentPatient, ["patient_uid"], 0);
  var getPatientData = function getPatientData() {
    var filterParams = getFilterParams(filters);
    var params = _objectSpread({
      page_size: pageSize
    }, filterParams);
    if (lastId) {
      params.pagination_id = lastId;
    }
    setPatientsLoading(true);
    getPatients(params, patientsData).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_patientsData) {
        var _emergencyPatients, _emergencyPatientsData, _updatedPatients;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _emergencyPatients = [];
              if (lastId) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getEmergencyPatients();
            case 1:
              _emergencyPatientsData = _context.v;
              _emergencyPatients = get(_emergencyPatientsData, ["data", "content"], []);
              setEmergencyPatients(_emergencyPatients);
              _context.n = 3;
              break;
            case 2:
              _emergencyPatients = emergencyPatients;
            case 3:
              _updatedPatients = updatePatientList(_patientsData || patientsData, _emergencyPatients);
              setPatientsData(_updatedPatients);
              setPatientsLoading(false);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (e) {
      setPatientsLoading(false);
    });
  };
  var getPatientCount = function getPatientCount() {
    var params = getFilterParams(filters);
    setIsCountLoading(true);
    getCounts(params).then(function (_count) {
      setCount(_count);
      setIsCountLoading(false);
    })["catch"](function () {
      setCount(0);
      setIsCountLoading(false);
    });
  };
  useEffect(function () {
    var fetchDefaultPrompts = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var BASE_URL, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              BASE_URL = process.env.NEXT_PUBLIC_MOBIUS_API_URL;
              _context2.n = 1;
              return fetch("".concat(BASE_URL, "/panacea/prompts/default"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 1:
              response = _context2.v;
              return _context2.a(2, response.json());
          }
        }, _callee2);
      }));
      return function fetchDefaultPrompts() {
        return _ref2.apply(this, arguments);
      };
    }();
    var fetchPrompts = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _get$find;
        var sourceId, BASE_URL, response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              sourceId = (_get$find = get(userInfo, ["upload_sources"], []).find(function (source) {
                return source.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
              })) === null || _get$find === void 0 ? void 0 : _get$find.uuid;
              BASE_URL = process.env.NEXT_PUBLIC_MOBIUS_API_URL;
              _context3.n = 1;
              return fetch("".concat(BASE_URL, "/panacea/prompts/post"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  source_id: sourceId
                })
              });
            case 1:
              response = _context3.v;
              return _context3.a(2, response.json());
          }
        }, _callee3);
      }));
      return function fetchPrompts() {
        return _ref3.apply(this, arguments);
      };
    }();
    fetchDefaultPrompts().then(function (res) {
      localStorage.setItem("defaultPrompts", JSON.stringify(res.prompts));
    })["catch"](function (err) {
      console.error(err);
    });
    fetchPrompts().then(function (res) {
      localStorage.setItem("prompts", JSON.stringify(res.prompts));
    })["catch"](function (err) {
      console.error(err);
    });
  }, [userInfo]);
  useEffect(function () {
    if (isLoggedIn) {
      getPatientData();
    }
  }, [lastId, pageSize, filters]);
  useEffect(function () {
    /* get total patient count just for display on top on worklist */
    if (isLoggedIn) {
      getPatientCount();
    }
  }, [filters]);
  useEffect(function () {
    if (isOnPremise) {
      if (!isMobile) {
        setIsFullWidthWorklist(true);
      }
      getSyncStatus().then(function (resp) {
        Store.update(function (s) {
          s.worklistSyncStatus = resp;
        });
      });
    } else {
      getCloudSyncStatus().then(function (resp) {
        Store.update(function (s) {
          s.worklistCloudSyncStatus = resp;
        });
      });
    }
  }, [isOnPremise]);

  // useEffect(() => {
  //   if (isOnPremise && isFullWidthWorklist) {
  //     getUnsyncCount().then((unsync_count) => {
  //       setUnsyncCount(unsync_count);
  //     });
  //   }
  // }, [isOnPremise, isFullWidthWorklist]);

  useEffect(function () {
    if (!isEmpty(currentPatient)) {
      var is_license_expired = get(currentPatient, ["is_license_expired"], false);
      findMatchingPatient(currentPatientUid);
      Store.update(function (s) {
        s.hasLicenseExpiredForSelectedPatient = is_license_expired;
      });
    }
  }, [currentPatientUid]);
  var getFilterParams = function getFilterParams(_filters) {
    var _filters$data;
    var filterParams = _objectSpread({}, (_filters$data = _filters === null || _filters === void 0 ? void 0 : _filters.data) !== null && _filters$data !== void 0 ? _filters$data : {});
    var startDate = get(filterParams, ["start_study_date"], "");
    var endDate = get(filterParams, ["end_study_date"], "");
    if (startDate) {
      var startDateVal = new Date(startDate);
      var endDateVal = add(new Date(endDate), {
        days: 1
      });
      if (isValidDate(startDateVal) && isValidDate(endDateVal)) {
        startDateVal.setHours(0, 0, 0);
        endDateVal.setHours(0, 0, 0);
        set(filterParams, ["start_study_date"], startDateVal.toISOString());
        set(filterParams, ["end_study_date"], endDateVal.toISOString());
      }
    }
    return filterParams;
  };
  var updatePatientUnreadCount = function updatePatientUnreadCount(currentPatientUid, hasNewMessage) {
    var patients = get(patientsData, ["data", "content"], []);
    var currentPatient = patients && patients.find(function (p) {
      return get(p, ["patient_uid"], 0) == currentPatientUid;
    });
    var count = 0;
    if (hasNewMessage) {
      count = get(currentPatient, ["unread_message_count"], 0) + 1;
    }
    if (currentPatient) {
      set(currentPatient, ["unread_message_count"], count);
      if (!isOnPremise) {
        set(currentPatient, ["sync_status", "cloud", "status"], constants.SYNC_STATUS.CLOUD.READ);
      }
    }
  };
  var getPatientsByEmergency = function getPatientsByEmergency(_patients) {
    var _emergencyPatients = [];
    var _nonEmergencyPatients = [];
    _patients.forEach(function (_pat) {
      if (get(_pat, ["emergency"], false) === true) {
        _emergencyPatients.push(_pat);
      } else {
        _nonEmergencyPatients.push(_pat);
      }
    });
    return {
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };
  var formPatientStateObject = function formPatientStateObject(_patients, _patientsData) {
    if (_patientsData) {
      var content = Object.assign(_patientsData, {
        data: _objectSpread(_objectSpread({}, _patientsData.data), {}, {
          content: _patients
        })
      });
      return content;
    }
    return _patientsData;
  };
  var updatePatientList = function updatePatientList(patientsData, _emergencyPatients) {
    var patientIds = _emergencyPatients.map(function (_pat) {
      return _pat.patient_uid;
    });
    var _patientsData = clone(patientsData);
    var _patients = get(_patientsData, ["data", "content"], []);
    _patients = _patients.filter(function (_pat) {
      return !patientIds.includes(_pat.patient_uid);
    });
    _patients = [].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_patients));
    return formPatientStateObject(_patients, _patientsData);
  };
  var findMatchingPatient = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_patientUid) {
      var matches;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!_patientUid) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return getMatchingPatient(_patientUid);
          case 1:
            matches = _context4.v;
            setMatchingPatients(matches);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function findMatchingPatient(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var relocateEmergencyPatient = function relocateEmergencyPatient(_patients, _targetPatient) {
    var _allPatientsList = _patients.filter(function (pat) {
      return pat.patient_uid != (_targetPatient === null || _targetPatient === void 0 ? void 0 : _targetPatient.patient_uid);
    });
    var _getPatientsByEmergen = getPatientsByEmergency(_allPatientsList),
      _emergencyPatients = _getPatientsByEmergen._emergencyPatients,
      _nonEmergencyPatients = _getPatientsByEmergen._nonEmergencyPatients;
    var hasEmergencyActivated = _targetPatient.emergency;
    if (hasEmergencyActivated) {
      // when emergency is activated
      var nextPatientIndex = _emergencyPatients.findIndex(function (_pat) {
        return _pat.last_image_study_uploaded_at && _targetPatient.last_image_study_uploaded_at && new Date(_pat.last_image_study_uploaded_at) < new Date(_targetPatient.last_image_study_uploaded_at);
      });
      if (nextPatientIndex >= 0) {
        _emergencyPatients = [].concat(_toConsumableArray(_emergencyPatients.slice(0, nextPatientIndex)), [_targetPatient], _toConsumableArray(_emergencyPatients.slice(nextPatientIndex)));
      } else {
        _emergencyPatients.push(_targetPatient);
      }
    } else {
      // when emergency is deactivated
      var _nextPatientIndex = _nonEmergencyPatients.findIndex(function (_pat) {
        return _pat.last_image_study_uploaded_at && _targetPatient.last_image_study_uploaded_at && new Date(_pat.last_image_study_uploaded_at) < new Date(_targetPatient.last_image_study_uploaded_at);
      });
      if (_nextPatientIndex >= 0) {
        _nonEmergencyPatients = [].concat(_toConsumableArray(_nonEmergencyPatients.slice(0, _nextPatientIndex)), [_targetPatient], _toConsumableArray(_nonEmergencyPatients.slice(_nextPatientIndex)));
      }
    }
    _allPatientsList = [].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_nonEmergencyPatients));
    return {
      _allPatientsList: _allPatientsList,
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };
  useEffect(function () {
    if (wsData) {
      var filterObj = localStorage.getItem(constants.PERSISTED.filterObj);
      var isFilterApplied = false;
      if (filterObj) {
        var _JSON$parse;
        isFilterApplied = (_JSON$parse = JSON.parse(filterObj)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isFilterApplied;
      }
      if (wsData.action == "new_message" || wsData.action == "update_message" || wsData.action == "unsubscribe" || wsData.action == "subscribe") {
        var _unreadMessages = clone(unreadMessages);
        if (wsData.action == "new_message") {
          var msgContent = get(wsData, ["content"], {});
          var msgPatientUid = get(msgContent, ["patient_uid"], 0);
          // --- Kept this code for future use ---
          // const msgsList = _unreadMessages[msgPatientUid] || []
          // msgsList.unshift(msgContent)
          set(_unreadMessages, [msgPatientUid], [msgContent]); // [...msgsList]
          if (get(msgContent, ["user"], "") !== userId && msgPatientUid != currentPatientUid) {
            updatePatientUnreadCount(msgPatientUid, true);
          }
          if ((get(msgContent, ["image_report_uid"], 0) > 0 || get(msgContent, ["image_study_uid"], 0) > 0) && msgPatientUid === currentPatientUid && isWorkList) {
            Store.update(function (s) {
              s.enableViewerAPICall = false;
              s.enableSidebarAPICall = false;
              s.hasUpdatedStudy = true;
            });
            setTimeout(function () {
              Store.update(function (s) {
                s.enableSidebarAPICall = true;
              });
            }, 500);
          }
        }
        if (wsData.action == "update_message") {
          var _msgContent = get(wsData, ["content"], {});
          setUpdatedMessage(_msgContent);
        }
        if (wsData.action == "unsubscribe") {
          var _msgPatientUid = get(wsData, ["patient_uid"], 0);
          set(_unreadMessages, [_msgPatientUid], []);
        }
        if (wsData.action == "subscribe") {
          var _msgPatientUid2 = get(wsData, ["patient_uid"], 0);
          updatePatientUnreadCount(_msgPatientUid2);
        }
        setUnreadMessages(_unreadMessages);
      }
      if (wsData.action == "new_patient" && !isFilterApplied) {
        var newPatient = get(wsData, ["content"], {});
        var _newPatientId = get(newPatient, ["patient_id"], "");
        var _newPatientUid = get(newPatient, ["patient_uid"], "");
        var _patientsData = clone(patientsData);
        var _patients = get(patientsData, ["data", "content"], []);
        var _getPatientsByEmergen2 = getPatientsByEmergency(_patients),
          _emergencyPatients = _getPatientsByEmergen2._emergencyPatients,
          _nonEmergencyPatients = _getPatientsByEmergen2._nonEmergencyPatients;
        _nonEmergencyPatients.unshift(newPatient);
        var updatedPatientData = formPatientStateObject([].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_nonEmergencyPatients)), _patientsData);
        setPatientsData(updatedPatientData);
        setCount(count + 1);
        // for auto selecting newly registered patient by user
        if (newPatientId && _newPatientId && newPatientId === _newPatientId) {
          if (isMobile) {
            var workList = document.getElementById("worklist-container");
            if (workList) {
              workList["scrollTop"] = 0;
            }
          } else {
            router.push("/patients/".concat(_newPatientUid)).then(function () {
              Store.update(function (s) {
                s.isFormSelectorVisible = isFormModalOpen;
              });
            });
          }
          Store.update(function (s) {
            s.newPatientId = "";
          });
        }
      }
      if (wsData.action === "new_emergency" || wsData.action === "update_emergency") {
        var newPatientEmergencyContent = get(wsData, ["content"], {});
        var patientId = get(newPatientEmergencyContent, ["patient_id"]);
        var stale = get(newPatientEmergencyContent, ["stale"], false);
        var _patientsData2 = clone(patientsData);
        var _patients2 = get(_patientsData2, ["data", "content"], []);
        // let _emergencyPatients: Partial<Patient>[] = clone(emergencyPatients);

        if (wsData.action === "update_emergency") {
          var _selectedEmergencyPatient = _patients2.find(function (_pat) {
            return _pat.patient_uid === patientId;
          });
          if (_selectedEmergencyPatient) {
            _selectedEmergencyPatient.emergency = !stale;
            _selectedEmergencyPatient.emergency_details = stale ? null : newPatientEmergencyContent;
            if (stale) {
              var _relocateEmergencyPat = relocateEmergencyPatient(_patients2, _selectedEmergencyPatient),
                _allPatientsList = _relocateEmergencyPat._allPatientsList,
                _emergencyPatients2 = _relocateEmergencyPat._emergencyPatients;
              _patients2 = _allPatientsList;
              setEmergencyPatients(_emergencyPatients2);
            }
          }
          if (currentPatient && _selectedEmergencyPatient && (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === _selectedEmergencyPatient.patient_uid) {
            setCurrentPatient(_objectSpread({}, _selectedEmergencyPatient));
          }
        } else if (wsData.action === "new_emergency") {
          var updatedPatient = _patients2.find(function (_pat) {
            return _pat.patient_uid === patientId;
          }) || {};
          if (!isEmpty(updatedPatient)) {
            updatedPatient = _objectSpread(_objectSpread({}, updatedPatient), {}, {
              emergency: !stale,
              emergency_details: newPatientEmergencyContent
            });
            var _relocateEmergencyPat2 = relocateEmergencyPatient(_patients2, updatedPatient),
              _allPatientsList2 = _relocateEmergencyPat2._allPatientsList,
              _emergencyPatients3 = _relocateEmergencyPat2._emergencyPatients;
            _patients2 = _allPatientsList2;
            setEmergencyPatients(_emergencyPatients3);
          } else {
            getPatientDetails(patientId).then(function (resp) {
              updatedPatient = get(resp, ["data"], {});
              if (!isEmpty(updatedPatient)) {
                var _relocateEmergencyPat3 = relocateEmergencyPatient(_patients2, updatedPatient),
                  _allPatientsList3 = _relocateEmergencyPat3._allPatientsList,
                  _emergencyPatients4 = _relocateEmergencyPat3._emergencyPatients;
                _patients2 = _allPatientsList3;
                setEmergencyPatients(_emergencyPatients4);
                var _updatedPatientData = formPatientStateObject(_patients2, _patientsData2);
                setPatientsData(_updatedPatientData);
              }
            })["catch"](function () {
              Toast.error("New emergency activated for a patient. Please refresh your worklist");
            });
          }
        }
        var _updatedPatientData2 = formPatientStateObject(_patients2, _patientsData2);
        setPatientsData(_updatedPatientData2);
      }
      if (wsData.action == "update_patient") {
        var _patientsData3 = clone(patientsData);
        var _newPatient = get(wsData, ["content"], {});
        var _patients3 = get(_patientsData3, ["data", "content"], []);
        var patientToUpdateIdx = _patients3.findIndex(function (p) {
          return p.patient_uid === _newPatient.patient_uid;
        });
        if (patientToUpdateIdx >= 0) {
          var oldPatient = _patients3[patientToUpdateIdx];
          if (_newPatient.last_image_study_uploaded_at && oldPatient.last_image_study_uploaded_at !== _newPatient.last_image_study_uploaded_at) {
            _patients3 = _patients3.filter(function (_pat) {
              return _pat.patient_uid !== _newPatient.patient_uid;
            });
            var _getPatientsByEmergen3 = getPatientsByEmergency(_patients3),
              _emergencyPatients5 = _getPatientsByEmergen3._emergencyPatients,
              _nonEmergencyPatients2 = _getPatientsByEmergen3._nonEmergencyPatients;
            _patients3 = [].concat(_toConsumableArray(_emergencyPatients5), [_newPatient], _toConsumableArray(_nonEmergencyPatients2));
          } else {
            _patients3[patientToUpdateIdx] = _newPatient;
          }
          var _updatedPatientData3 = formPatientStateObject(_patients3, _patientsData3);
          setPatientsData(_updatedPatientData3);
          if ((currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === (_newPatient === null || _newPatient === void 0 ? void 0 : _newPatient.patient_uid)) {
            setCurrentPatient(_newPatient);
          }
        }
      }
      if (wsData.action === "export_download_started") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.downloadProgress = wsData.progress;
          s.exportGenFailed = false;
        });
      }
      if (wsData.action === "export_download_progress") {
        Store.update(function (s) {
          s.isExportReady = false;
          s.exportGenFailed = false;
          s.downloadProgress = wsData.progress;
        });
      }
      if (wsData.action === "export_generation_complete") {
        Store.update(function (s) {
          s.isExportReady = true;
          s.exportGenFailed = false;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
        // Api call to download the Export file
        downloadFile();
      }
      if (wsData.action === "export_download_failed") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.isExportReady = false;
          s.exportGenFailed = true;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
      }
      if (wsData.action === "patient_file_deletion") {
        Store.update(function (s) {
          s.patientsFileDeletionStatus = wsData.status;
        });
      }
      if (wsData.action === "sync_status_live_update") {
        Store.update(function (s) {
          s.worklistSyncStatus = get(wsData, ["content"], {});
        });
      }
      if (wsData.action === "sync_status_cloud_update") {
        var _syncStatus = get(wsData, ["content"], {});
        var workspace_name = get(_syncStatus, ["workspace_name"], "");
        var kind = get(_syncStatus, ["kind"], "");
        var last_synced_at = get(_syncStatus, ["last_synced_at"], "");
        if (workspace_name && kind == "success") {
          var _worklistCloudSyncStatus = cloneDeep(worklistCloudSyncStatus);
          var currentWorkspace = _worklistCloudSyncStatus[workspace_name];
          if (currentWorkspace) {
            currentWorkspace.payload = {
              kind: kind,
              last_synced_at: last_synced_at,
              workspace_name: workspace_name
            };
            _worklistCloudSyncStatus[workspace_name] = currentWorkspace;
            Store.update(function (s) {
              s.worklistCloudSyncStatus = _worklistCloudSyncStatus;
            });
          }
        }
      }
    }
  }, [wsData]);
  return /*#__PURE__*/React.createElement(PatientsContext.Provider, {
    value: {
      patientsData: patientsData,
      setPatientsData: setPatientsData,
      getPatientData: getPatientData,
      getPatientCount: getPatientCount,
      updatePatientUnreadCount: updatePatientUnreadCount,
      updatedMessage: updatedMessage,
      setUpdatedMessage: setUpdatedMessage,
      unreadMessages: unreadMessages,
      setUnreadMessages: setUnreadMessages,
      currentPatient: currentPatient,
      setCurrentPatient: setCurrentPatient,
      getFilterParams: getFilterParams,
      lastId: lastId,
      setLastId: setLastId,
      isPatientsLoading: isPatientsLoading,
      setPatientsLoading: setPatientsLoading,
      filters: filters,
      setFilters: setFilters,
      count: count,
      // unsyncCount,
      isCountLoading: isCountLoading,
      setIsFullWidthWorklist: setIsFullWidthWorklist,
      isFullWidthWorklist: isFullWidthWorklist,
      matchingPatients: matchingPatients,
      setMatchingPatients: setMatchingPatients,
      savedFilterData: savedFilterData,
      setSavedFilterData: setSavedFilterData,
      socket: socket,
      wsData: wsData
    }
  }, children);
};